import { type ADFNode, type ADFDocument } from '@canvas/adf-types';

const emptyParagraph = (input: ADFNode): boolean => {
  if (input.type !== 'paragraph') {
    return false;
  }

  return !input.content?.some((node) => node.type !== 'text' || node.text.trim() !== '');
};

export const isEmpty = (adf?: ADFDocument): boolean => {
  if (!adf) {
    return true;
  }

  return !adf.content?.some((node) => !emptyParagraph(node));
};

const emptyHeading = (input: ADFNode): boolean => {
  if (input.type !== 'heading') {
    return false;
  }

  return !input.content.some((item) => item.type !== 'text' || item.text.trim() !== '');
};

export const isEmptyWithHeading = (adf: ADFDocument): boolean => {
  if (isEmpty(adf)) {
    return true;
  }

  return !adf.content?.some((node) => !emptyHeading(node));
};
